<app-tiny-bot-spinner [inv]="true"></app-tiny-bot-spinner>
